import { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import { useSelector } from 'react-redux'
import DashboardMenu from '../dashboard/DashboardMenu'
import { UpdateLiveClassService } from '../../services/LiveClassServices'


function LiveClassListCE() {

  const auth = useSelector(state=>state.Auth)
  const [data, setdata] = useState({ topic: '', description: '', teacher_name: '', qualification: '', start_time: '', duration: '' });
  const [error, seterror] = useState({ topic: '', description: '', teacher_name: '', qualification: '', start_time: '', duration: '' });


  
  const { state } = useLocation();
  const [department, setdepartment] = useState([])
  const [users, setusers] = useState([])
  const navigate = useNavigate();


  useEffect(() => {
    if (state?._id !== null && state?._id !== undefined) {

      let obj = {
        ...state,

      }
      setdata({ ...data, ...obj })
    }

  }, [state])

  function handlechange(e) {
    setdata({ ...data, [e.target.name]: e.target.value })
    seterror({ ...error, [e.target.name]: '' })
  }

  


  async function submitform() {
    if (!data.topic) {
      seterror({ ...error, topic: 'This field is required *' })
    } else if (!data.description) {
      seterror({ ...error, description: 'This field is required *' })
    } else if (!data.teacher_name) {
      seterror({ ...error, teacher_name: 'This field is required *' })
    } else {
      let sendData = { ...data }
      
        sendData["id"] = state?._id
        const response = await UpdateLiveClassService(sendData, state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Live Class Updated Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.topic) {
            seterror({ ...error, topic: response?.data?.errors?.title })
          }
        }
    }
  }

  async function resetform() {
    setdata({ topic: '', description: '', teacher_name: '', qualification: '', start_time: '', duration: '' })
    seterror({ topic: '', description: '', teacher_name: '', qualification: '', start_time: '', duration: '' })
  }



  return (
    <div className='md:flex '>


      <DashboardMenu />

      <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack />



        <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} Live Class</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Live Class</b> came to visit you.</h6>


        <TextInput
          mandatory={true}
          label={'Topic'}
          variant="standard"
          name="topic"
          error={error.topic}
          value={data.topic}
          handlechange={handlechange}
          placeholder=""
          InputLabelProps={{
            style: { color: '#fff', },
          }} />

              <TextAreaInput1
          label={'Description'}
          variant="standard"
          name="description"
          type="text"
          error={error.description}
          value={data.description}
          handlechange={handlechange}
          placeholder=""
          InputLabelProps={{
            style: { color: '#fff', },
          }} />

        <TextInput
          mandatory={true}
          label={'Teacher Name'}
          variant="standard"
          name="teacher_name"
          type="text"
          error={error.teacher_name}
          value={data.teacher_name}
          handlechange={handlechange}
          placeholder=""
          InputLabelProps={{
            style: { color: '#fff', },
          }} />



        <TextInput
          mandatory={true}
          label={'Qualification'}
          variant="standard"
          name="qualification"
          error={error.qualification}
          value={data.qualification}
          handlechange={handlechange}
          placeholder=""
          InputLabelProps={{
            style: { color: '#fff', },
          }} />


        <TextInput
          mandatory={true}
          label={'Start Time'}
          variant="standard"
          name="start_time"
          error={error.start_time}
          value={data.start_time}
          handlechange={handlechange}
          placeholder=""
          InputLabelProps={{
            style: { color: '#fff', },
          }} />  

         <TextInput
          mandatory={true}
          label={'Duration'}
          variant="standard"
          name="duration"
          error={error.duration}
          value={data.duration}
          handlechange={handlechange}
          placeholder=""
          InputLabelProps={{
            style: { color: '#fff', },
          }} />    

       



    

        <div className='my-5'>
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE LIVE CLASS" : "ADD LIVE CLASS"} onClick={submitform} />
        </div>


      </div>
    </div>
  )
}

export default LiveClassListCE